import { useAuth } from 'common-react/auth/AuthProvider';
import { AuthGuard } from 'common-react/auth/guards/AuthGuard';
import { LoginGuard } from 'common-react/auth/guards/LoginGuard';
import { FullPageLoader } from 'components/BouncingLoader/FullPageLoader';
import { CompanySelectorLandingContainer } from 'components/NavBar/CompanySelectorLandingContainer';
import { AvailabilityWrapper } from 'pages/Availability/AvailabilityWrapper';
import { CompanyPageWrapper } from 'pages/CompanyWrapper/CompanyPageWrapper';
import { ErrorPage } from 'pages/Error/ErrorPage';
import { Intro } from 'pages/Intro/Intro';
import { AssetOperations } from 'pages/Operations/AssetOperations/AssetOperations';
import { OperationsOverview } from 'pages/Operations/OperationsOverview/OperationsOverview';
import { SiteOperations } from 'pages/Operations/SiteOperations/SiteOperations';
import { OptimisationWrapper } from 'pages/Optimisation/OptimisationWrapper';
import { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router';
import AppContainer from 'router/AppContainer';
import { logAppError } from 'utils/logging';

export const ROOT_PATH = '/';
export const LOGIN_PATH = '/home';
export const COMPANY_SELECTOR_PATH_PART = 'company-selector';

export const COMPANY_SELECTOR_PATH = `${ROOT_PATH}${COMPANY_SELECTOR_PATH_PART}`;

const OptimisationRouteConditionalParams = '/:site?/:asset?';
const AvailabilityRouteConditionalParams = '/:site?';

const AppRoutes = () => {
  const { authStoreAccess } = useAuth();

  const onLoginTimeout = useCallback(() => {
    // eslint-disable-next-line no-console
    console.error('Login has timed out.');

    authStoreAccess.clearAuthState();

    window.location.reload();
  }, [authStoreAccess]);

  return (
    <ErrorBoundary FallbackComponent={ErrorPage} onError={logAppError}>
      <Routes>
        <Route
          path={ROOT_PATH}
          element={
            <AuthGuard loginPath={LOGIN_PATH}>
              <AppContainer />
            </AuthGuard>
          }
        >
          <Route path=":company?" element={<CompanyPageWrapper />}>
            <Route
              path={'optimisation' + OptimisationRouteConditionalParams}
              element={<OptimisationWrapper />}
            />
            <Route path="operations" element={<OperationsOverview />}>
              <Route path={':site'} element={<SiteOperations />} />
              <Route path={':site/:asset'} element={<AssetOperations />} />
            </Route>
            <Route
              path={'availability' + AvailabilityRouteConditionalParams}
              element={<AvailabilityWrapper />}
            />
          </Route>

          <Route
            path={COMPANY_SELECTOR_PATH_PART}
            element={
              <AuthGuard loginPath={LOGIN_PATH}>
                <CompanySelectorLandingContainer />
              </AuthGuard>
            }
          />
        </Route>
        {/* <Route path="*" element={<NotFoundErrorState />} /> */}
        <Route
          path={LOGIN_PATH}
          element={
            <LoginGuard
              loadingComponent={<FullPageLoader />}
              onLoginTimeout={onLoginTimeout}
            >
              <Intro />
            </LoginGuard>
          }
        />
      </Routes>
    </ErrorBoundary>
  );
};

export default AppRoutes;
